export default "__VITE_ASSET__QhIVNp1Q__"